'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var sizes = require('../../../constants/sizes.js');
var Badge = require('../../Badge/src/Badge.js');
var Space = require('../../Space/src/Space.js');
var RadioButton_module = require('../styles/RadioButton.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description The RadioButton is a simple way to create button groups in most use cases
 *
 * @component
 * @example
 * ```jsx
 * <RadioButton options={options} defaultValue={value}>
 * ```
 */
const RadioButton = React__namespace.forwardRef((props, ref) => {
    const { options, value, defaultValue, size, border, className, onChange, ...restProps } = props;
    const cx = reactUtils.useStyles(RadioButton_module.default);
    const id = reactUtils.useId('radio-button');
    const isFirstRender = React__namespace.useRef(true);
    const [innerValue, setInnerValue] = React__namespace.useState(value || defaultValue);
    const classNames = cx(className, 'container', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'with-border': border,
    });
    const handleSelect = React__namespace.useCallback((value) => () => {
        setInnerValue(value);
        onChange?.(value);
    }, [onChange]);
    const buttons = React__namespace.useMemo(() => {
        if (options && Array.isArray(options)) {
            return options.map(({ label, value, disabled, badgeText }) => {
                const classNames = cx('button', {
                    [`size-${size}`]: size,
                    active: innerValue === value,
                    disabled,
                });
                return (React__namespace.createElement("button", { key: `${id}-${value}`, type: "button", className: classNames, onClick: disabled ? reactUtils.noop : handleSelect(value) },
                    React__namespace.createElement(Space.Space, { size: 4, justify: "center" },
                        label,
                        badgeText && React__namespace.createElement(Badge.Badge, { text: badgeText }))));
            });
        }
        return null;
    }, [options, cx, size, innerValue, id, handleSelect]);
    React__namespace.useEffect(() => {
        if (!isFirstRender.current) {
            setInnerValue(value);
            return;
        }
        isFirstRender.current = false;
    }, [value]);
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "RadioButton", className: classNames, ...restProps }, buttons));
});
RadioButton.defaultProps = {
    size: sizes.CONTAINER_SIZES.S36,
    border: false,
};
RadioButton.displayName = 'RadioButton';

exports.RadioButton = RadioButton;
//# sourceMappingURL=RadioButton.js.map
